/** CoursesU catalog routes for supplier 7 (mealz-ssr-api routing.json). */
export const COURSESU_CATALOG_ROUTES = {
  home: {
    section: "",
    htmlEndpoint: "/v3/catalog",
    stylesEndpoint: "/v3/styles/catalog/catalog-home",
  },
  list: {
    section: "liste",
    htmlEndpoint: "/v3/catalog/list",
    stylesEndpoint: "/v3/styles/catalog/catalog-list",
  },
  category: {
    section: "categorie",
    htmlEndpoint: "/v3/catalog/category",
    stylesEndpoint: "/v3/styles/catalog/catalog-category",
  },
  mySpace: {
    section: "mon-carnet",
    htmlEndpoint: "/v3/catalog/my-space",
    stylesEndpoint: "/v3/styles/catalog/my-space",
  },
};


/** CoursesU category URLs use a retailer path; SSR expects the trailing Mealz package id. */
function parseCoursesUCategoryId(categorie) {
  return categorie.match(/(?:^|\/)(\d+)\/?$/)?.[1] ?? categorie;
}

export function buildForwardedQueryParams() {
  const searchParams = new URLSearchParams(globalThis.location.search);
  const params = {};

  for (const [key, value] of searchParams.entries()) {
    if (key === "section") {
      continue;
    }
    params[key] = value;
  }

  if (params.categorie && !params.category_id) {
    params.category_id = parseCoursesUCategoryId(params.categorie);
    delete params.categorie;
  }

  return params;
}

export function getCatalogSsrEndpoints() {
  const section = new URLSearchParams(globalThis.location.search).get("section");

  return Object.values(COURSESU_CATALOG_ROUTES).find(
    ({ section: routeSection }) => routeSection === section,
  ) ?? COURSESU_CATALOG_ROUTES.home;
}
